import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const FooterFlex = styled(Flex)`
  gap: 15px;
`

export const Label = styled(Flex)`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: #1b1f22;
  margin-bottom: 8px;
`
export const FlexWrap = styled(Flex)`
  width: ${props => (props.width ? props.width : '100%')};
  gap: ${props => (props.gap ? props.gap : '0')};
  margin: 8px 0;
`

export const TextDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 20px;
  color: ${COLORS.GREY_T_20};
`
export const StartSpan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const GapSpan = styled.div`
  margin: 10px 0;
`
export const CommonFlex = styled(Flex)`
  margin: 35px 0;
`
